import CarItem from "@/features/CarItem";
import CarListFilter from "@/features/CarListFilter";
import { Divider } from "@/components/ui/divider";
import { PriceResultProps } from "@/lib/type";
import { useMemo } from "react";

interface ChooseVehicleProps {
  driverAge: number;
  priceData: PriceResultProps[];
  onSelect: any;
  rentalDays: number;
}

const ChooseVehicle: React.FC<ChooseVehicleProps> = ({
  driverAge,
  priceData,
  onSelect,
  rentalDays
}) => {
  const filteredCarItems = useMemo(() => {
    if (priceData.length === 0) return null;
    // Ensure driverAge is numeric, fallback to 0 if invalid
    return priceData
      // .filter((e) => e.group_detail.min_age >= (driverAge ?? 0))
      .filter((e) => {
        const minAge = e.group_detail.min_age;
        const parsedDriverAge = typeof driverAge === "number" ? driverAge : 0;
        return parsedDriverAge >= minAge;
      })
      .map((e, index) => (
        <div key={`div${e.group.id}-${index}`} className="py-2">
          <CarItem
            index={index}
            key={e.group.id}
            onSelect={() => onSelect(e)}
            car={e}
            rentalDays={rentalDays}
          />
          {index === priceData.length - 1 ? null : <Divider />}
        </div>
      ));
  }, [priceData, driverAge, rentalDays, onSelect]);
  return (
    <>
      <p className="font-bold mb-2 text-2xl">Choose your vehicle</p>
      <CarListFilter numberOfAvailable={priceData.length} />
      <Divider />
      <div className="mt-4">
      {filteredCarItems}
      </div>
    </>
  );
};

export default ChooseVehicle;
